module.exports = __webpack_public_path__ + "img/tot.0c8d7433.png";